import React, {useEffect, useMemo, useState} from 'react';
import {Divider, Empty, notification, Spin, Tag} from 'antd';
import {authAPI} from "../../services/AuthService";
import {Navbar} from "../../components/Navbar";
import {Bar, G2} from '@ant-design/plots';
import {DataGridPremium, gridClasses, GridColDef, GridRenderCellParams, ruRU} from "@mui/x-data-grid-premium";
import {TaskGridModel} from "../../models/TaskGridModel";
import {host, port, secure} from "../../config/config";

const Context = React.createContext({name: 'FilialsScreen'});

export const WidgetsScreen: React.FC = () => {
    // Notification
    const [api, contextHolder] = notification.useNotification();
    const contextValue = useMemo(() => ({name: 'Ant Design'}), []);
    // -----
    const [selectedFilial, setSelectedFilial] = useState<string | null>(null);
    const [redirectToLogin, setRedirectToLogin] = useState<boolean>(false);
    // Return to login if reject token verify
    const [verifyTokenRequest, {status: statusVerifyTokenRequest}] = authAPI.useVerifyTokenMutation();
    useEffect(() => {
        verifyTokenRequest();
    }, [])
    useEffect(() => {
        if (statusVerifyTokenRequest === 'rejected') {
            setRedirectToLogin(true);
        }
    }, [statusVerifyTokenRequest])
    // -----
    const [gridData, setGridData] = useState<TaskGridModel[]>([]);
    const [data, setData] = useState([]);
    const [dataDetails, setDataDetails] = useState([]);

    useEffect(() => {
        asyncFetch();
    }, []);

    useEffect(() => {
        asyncFetchDetails()
    }, [selectedFilial]);

    const asyncFetch = () => {
        fetch(`${secure}://${host}${port}/tasks/report`)
            .then((response) => response.json())
            .then((json) => setData(json))
            .catch((error) => {
                console.log('fetch data failed', error);
            });
    };

    const asyncFetchDetails = () => {
        fetch(`${secure}://${host}${port}/tasks/report/${selectedFilial}`)
            .then((response) => response.json())
            .then((json) => {
                setDataDetails(json.data);
                setGridData(json.tasks);
            })
            .catch((error) => {
                console.log('fetch data details failed', error);
            });
    };

    G2.registerInteraction('element-link', {
        start: [
            {
                trigger: 'interval:mouseenter',
                action: 'element-link-by-color:link',
            },
        ],
        end: [
            {
                trigger: 'interval:mouseleave',
                action: 'element-link-by-color:unlink',
            },
        ],
    });
    const config = {
        isStack: true,
        xField: 'value',
        yField: 'filial',
        seriesField: 'status',
        label: {
            // 可手动配置 label 数据标签位置
            position: 'middle',
            // 'left', 'middle', 'right'
            // 可配置附加的布局方法
            layout: [
                // 柱形图数据标签位置自动调整
                {
                    type: 'interval-adjust-position',
                }, // 数据标签防遮挡
                {
                    type: 'interval-hide-overlap',
                }, // 数据标签文颜色自动调整
                {
                    type: 'adjust-color',
                },
            ],
        },
        colorField: 'type', // or seriesField in some cases
        color: ({ status }:any) => {
            console.log(status)
            if(status === 'Выполнено')
                return '#b7eb8f';
            else if(status === 'В работе')
                return '#91caff'
            else if(status === 'Создано')
                return '#ffbb96'
            return 'yellow';
        }
    };
    const columns: GridColDef[] = [
        {fieldName: "Статус", field: 'status'},
        {fieldName: "Дата", field: 'date'},
        {fieldName: "Объект", field: 'filialAndObject'},
        {fieldName: "Оборудование", field: 'equipment'},
        {fieldName: "Заказчик", field: 'creator'},
        {fieldName: "Заявленная неисправность", field: 'title'},
        {fieldName: "Описание неисправности", field: 'description'},
    ].map((col: { fieldName: string, field: string }) => {
        return {
            field: col.field,
            headerName: col.fieldName,
            minWidth: 150,
            width: 150,
            editable: false,
            type: col.field === 'date' ? 'dateTime' : 'string',
            valueGetter: (params) => {
                if (params.value === undefined)
                    return params.value;
                if (col.field === 'date') {
                    return new Date(params.value)
                }
                return params.value;
            },
            renderCell: (params: GridRenderCellParams<any, any>) => {
                if (col.field === 'status') {
                    return <Tag color={params.value === 'Создано' ? 'volcano' :
                        params.value === 'В работе' ? 'processing' : 'success'}>{params.value}</Tag>
                }
            }
        }
    })
    return (
        <Context.Provider value={contextValue}>
            {contextHolder}
            <Navbar/>
            <div style={{display: 'flex'}}>
                <div style={{width: window.innerWidth * 0.45, padding: 10, height: window.innerHeight - 80}}>
                    {/*//@ts-ignore}*/}
                    <Bar {...config} loading={data.length === 0} data={data} onEvent={(chart, event) => {
                        if (event.type === 'click') {
                            if (event.data) {
                                setDataDetails([])
                                setSelectedFilial(event.data.data.filial);
                            }
                        }
                    }}/>
                </div>
                <Divider type={"vertical"} style={{height: window.innerHeight - 46}}/>
                <div style={{width: window.innerWidth * 0.45, padding: 10, height: window.innerHeight - 80}}>
                    {selectedFilial === null ?
                        <Empty style={{marginTop: 250}} description={<span>Данные не выбраны</span>}/>
                        :
                        dataDetails.length === 0 ?
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignContent: 'center',
                                marginTop: (window.innerHeight - 100) * 0.5
                            }}>
                                <Spin size={'large'}/>
                            </div>
                            :
                            <div style={{display: 'flex', flexDirection: 'column'}}>
                                <div style={{display: 'flex', justifyContent: 'center'}}>
                                    <strong className={"ant-menu-title-content"}>{selectedFilial}</strong>
                                </div>
                                <div style={{width: window.innerWidth * 0.50, height: window.innerHeight * 0.3}}>
                                    {/*//@ts-ignore}*/}
                                    <Bar {...config} data={dataDetails}/>
                                </div>
                                <div style={{height: (window.innerHeight - 46) * 0.60, paddingTop: 15}}>
                                    <DataGridPremium
                                        style={{width: window.innerWidth * 0.5}}
                                        localeText={ruRU.components.MuiDataGrid.defaultProps.localeText}
                                        rows={gridData}
                                        columns={columns}
                                        getRowHeight={() => 'auto'}
                                        columnHeaderHeight={30}
                                        initialState={{
                                            sorting: {
                                                sortModel: [{field: 'date', sort: 'desc'}],
                                            },
                                        }}
                                        sx={{
                                            [`& .${gridClasses.cell}`]: {
                                                py: 1,
                                            },
                                        }}
                                        /*@ts-ignore*/
                                        pageSize={20}
                                        rowsPerPageOptions={[20]}
                                        disableSelectionOnClick
                                    />
                                </div>
                            </div>
                    }
                </div>
            </div>
        </Context.Provider>
    );
}